import {TreeSelect} from "antd";

export const config =  {
  fieldControl: false,
  columns: [
    {
      title: '身份ID',
      dataIndex: 'id',
      width: 200,
    },
    {
      title: '姓名',
      dataIndex: 'userName',
      width: 160,
      ellipsis: true,
    },
    {
      title: '组织',
      dataIndex: 'orgNamePath',
      width: 140,
      ellipsis: true,
    },
    {
      title: '角色',
      dataIndex: 'roleName',
      width: 140,
      ellipsis: true,
    },
  ],
  search: [
    {
      label: '组织',
      name: 'orgIds',
      itemType: 'tree',
      treeCheckable: true,
      data: 'orgList',
      labelKey: 'label',
      key: 'id',
      showCheckedStrategy: TreeSelect.SHOW_PARENT
    },
    {
      label: '姓名',
      name: 'userNameKeyword',
    },
    {
      label: '角色',
      name: 'roleIds',
      mode: 'multiple',
      itemType: 'select',
      data: 'roleList',
      labelKey: 'name',
      key: 'id',
    }
  ],
}
